// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AGnP","colBig":"styles_colBig__1PsLV","colSmall":"styles_colSmall__1PWzQ"};